import { render, staticRenderFns } from "./AzGroupsEdit.vue?vue&type=template&id=d1799ef2"
import script from "./AzGroupsEdit.vue?vue&type=script&lang=js"
export * from "./AzGroupsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports